<template>
  <!-- <ul class="footer flex jc-sa w100pc fixed bott0 bg-fff aic footer">
    <li class="item">
      <router-link to="/index" class="flex2 aic f20 yellow" active-class="active">
        <i class="icon-home iconfont f18 text"></i>
        <p class="mt-5 f12 text">首页</p>
      </router-link>
    </li>
 
    <li class="item">
      <router-link to="/my" class="flex2 aic f20 text" active-class="active">
        <van-icon class="text" name="user-o"></van-icon>
        <p class="mt-5 text f12">我的</p>
      </router-link>
    </li>
  </ul> -->
  <div>
    <van-tabbar v-model="active" active-color="#FF960B">
    <van-tabbar-item to="/index">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/index_active.png') : require('../assets/img/index.png')" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item  to="/my">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/mine_active.png'):require('../assets/img/mine.png')" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  </div>
</template>

<script>
export default {
  data(){
    return{
      active: 0,
      icon:[ {
        active: require('../assets/img/index_active.png'),
        inactive: require('../assets/img/index.png'),
      },{
        active:require('../assets/img/mine_active.png'),
        inactive:require('../assets/img/mine.png')
      }],
    }
  },
  watch:{
    $route(){
      console.log(this.$route)
      if(this.$route.path=='/my'){
        this.active=1
      }else{
        this.active=0
      }
    }
  },
  mounted(){
    if(this.$route.path=='/my'){
        this.active=1
      }else{
        this.active=0
      }
  }
  
};
</script>

<style scoped lang="less">
.footer {
  border-top: 1px solid #ebebeb;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  bottom: 0;
  left: 0;
  .text {
    color: #797d82;
  }
  .active .text {
    color: @orange;
  }
  .tab_img{
    width: 28px;
    height: 28px;
  }
}
</style>
